"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configDefault = void 0;
const PrettyLoaderType_1 = require("./PrettyLoaderType");
const configDefault = {
    type: PrettyLoaderType_1.PrettyLoaderType.dots,
    color: '#3861fb',
    size: 8,
    circleSize: 20,
};
exports.configDefault = configDefault;
